import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { type ModelProfileResponse } from "../ChatRecord";

const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

/**
 * Fetches available model profiles from the API.
 * Cached for 15 minutes since profiles change rarely.
 */
export function useModelProfiles() {
  const { chatService } = useDomainServices();
  const orgId = useCurrentOrgId();

  return useQuery<ModelProfileResponse[]>({
    queryKey: ["modelProfiles", orgId],
    queryFn: ({ signal }) =>
      chatService.getModelProfiles({ abortSignal: signal, orgId }),
    staleTime: FIFTEEN_MINUTES_MS,
  });
}
